import axios from "axios";
import { decryptData, encryptData } from "./cryptoHelper";

const api = axios.create({
  baseURL: "https://relphacareapi.com/api/",
  // baseURL: "http://3.223.139.233:8000/",
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  async function (config) {
    try {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = "Bearer " + token;
      }
      config.headers.platform = "web";
      if (config.data) {
        const encrypted = encryptData(config.data);
        config.data = JSON.stringify({
          iv: encrypted.iv,
          ciphertext: encrypted.ciphertext,
        });
      }

      return config;
    } catch (error) {
      console.error("Request interceptor error:", error);
      return Promise.reject(error);
    }
  },
  function (error) {
    return Promise.reject(error);
  }
);

export const responseInterceptor = (navigate) => {
  return api.interceptors.response.use(
    async (response) => {
      try {
        if (response.data && response.data.iv && response.data.ciphertext) {
          const { iv, ciphertext } = response.data;
          const decryptedData = decryptData({ iv, ciphertext });
          response.data = decryptedData;
        }
        return response;
      } catch (decryptionError) {
        console.error("Decryption error:", decryptionError);
        throw new Error("Failed to decrypt the response data");
      }
    },
    (error) => {
      if (error.response && error.response.status === 401) {
        try {
          delete error.config.headers.Authorization;
          localStorage.removeItem("token");
          navigate("/");
        } catch (navigationError) {
          console.error("Navigation error:", navigationError);
        }
      }
      return Promise.reject(error);
    }
  );
};

export default api;
